import { render, staticRenderFns } from "./HistorialConsultas.vue?vue&type=template&id=603ba472&scoped=true"
import script from "./HistorialConsultas.vue?vue&type=script&lang=js"
export * from "./HistorialConsultas.vue?vue&type=script&lang=js"
import style0 from "./HistorialConsultas.vue?vue&type=style&index=0&id=603ba472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ba472",
  null
  
)

export default component.exports